import PropTypes from 'prop-types';
import useAssetTypeSelect from './useAssetTypeSelect';
import { DropdownSelect } from '../dropdown-select/DropdownSelect';
import { useDictionaryTranslation } from '../../hooks/useDictionaryTranslation';

const SelectAssetType = ({ placeholder, multiple = false, includeOnlyGeoActive = false, onChange, value, width }) => {
  const isObjectValue = value && typeof value === 'object';
  const { assetsTypes, isLoading, getAssetTypes, selectedOption } = useAssetTypeSelect({
    includeOnlyGeoActive,
    selectedId: isObjectValue ? undefined : value,
  });
  const { translate: t } = useDictionaryTranslation();

  const transformedAssets = assetsTypes.map((assetType) => ({
    value: assetType._id,
    label: assetType.name,
    data: assetType
  }));

  const selectedValue = isObjectValue ? value : selectedOption;

  return (
    <>
      <DropdownSelect
        style={{ width: width ? '100%' : '74%' }}
        placeholderText={placeholder || t('selectAssetType')}
        onSearch={getAssetTypes}
        isLoading={isLoading}
        options={transformedAssets}
        multiple={multiple}
        onChange={onChange}
        value={selectedValue}
      />
    </>
  );
};

export default SelectAssetType;

SelectAssetType.propTypes = {
  multiple: PropTypes.bool,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  width: PropTypes.bool,
  includeOnlyGeoActive: PropTypes.bool
};
